import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { InlineInput } from 'seagull/components/TableList/InlineControl/InlineInput';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { AccountingMappingIndication } from '~/integrations/Accounting/AccountingMappingIndication/AccountingMappingIndication';
import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
import { Accounting } from '~/types/api.model';
import styles from './ServiceRowName.module.scss';
export function ServiceRowName(param) {
    let { service, serviceNameValidation, qboServiceDisplay, xeroServiceDisplay, onInlineEdit, onInputFocus, onInputBlur } = param;
    const showQboIntegration = useStore(selectors.integration.showQboIntegration);
    const showXeroIntegration = useStore(selectors.integration.showXeroIntegration);
    const { control, setValue } = useForm({
        mode: 'all',
        defaultValues: {
            name: service.name
        }
    });
    const { XERO_INTEGRATION } = useFeatureFlags();
    useEffect(()=>{
        setValue('name', service.name);
    }, [
        service.name,
        setValue
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.serviceName,
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "name",
                rules: serviceNameValidation,
                render: (param)=>{
                    let { field, fieldState } = param;
                    var _fieldState_error;
                    return /*#__PURE__*/ _jsx(InlineInput, _object_spread_props(_object_spread({}, field), {
                        onFocus: onInputFocus,
                        onBlur: onInputBlur,
                        onSave: (name)=>onInlineEdit({
                                name
                            }),
                        error: !!fieldState.error,
                        errorText: (_fieldState_error = fieldState.error) === null || _fieldState_error === void 0 ? void 0 : _fieldState_error.message,
                        errorTextInTooltip: true,
                        testId: "service-library-row-name"
                    }));
                }
            }),
            showQboIntegration && /*#__PURE__*/ _jsx(AccountingMappingIndication, {
                display: qboServiceDisplay,
                purpose: "service",
                accounting: Accounting.QBO
            }),
            showXeroIntegration && XERO_INTEGRATION && /*#__PURE__*/ _jsx(AccountingMappingIndication, {
                display: xeroServiceDisplay,
                purpose: "service",
                accounting: Accounting.Xero
            })
        ]
    });
}
